module.exports = {"230882001":"城东街道","230882003":"城西街道","230882102":"富锦镇","230882103":"长安镇","230882106":"砚山镇","230882107":"头林镇","230882108":"兴隆岗镇","230882109":"宏胜镇","230882110":"向阳川镇","230882111":"二龙山镇","230882112":"上街基镇","230882113":"锦山镇","230882114":"大榆树镇","230882400":"石砬山林场","230882401":"东风岗林场","230882402":"太东林场","230882403":"工农林场","230882404":"富锦市国营原种场","230882405":"富锦市国营果树示范场","230882406":"富锦市科研所","230882407":"工业园区","230882500":"建三江管理局局直","230882501":"七星农场","230882502":"大兴农场","230882503":"创业农场","230882580":"种猪场","230882581":"种畜场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230882.json
// module id = 864
// module chunks = 0